var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedicalExaminationOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#medical-examination-outline_svg__clip0_230_2228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0a1 1 0 011 1v2a1 1 0 01-2 0H2.196l1.49 11.03c.122.554.536.87 1.014.87h6.5c.568 0 .964-.388 1.005-.8a1.06 1.06 0 01.005-.043L13.804 3H12a1 1 0 11-2 0V1a1 1 0 012 0h1.8c1.108 0 2.198.949 1.988 2.252l-1.595 11.071c-.17 1.575-1.568 2.577-2.993 2.577H9V22h10v-4.126A4.002 4.002 0 0120 10a4 4 0 011 7.874V23a1 1 0 01-1 1H8a1 1 0 01-1-1v-6.1H4.7c-1.514 0-2.695-1.074-2.98-2.504a.996.996 0 01-.011-.062L.211 3.247a1.92 1.92 0 01.436-1.58C1.04 1.218 1.607 1 2.2 1H4a1 1 0 011-1zm15 12a2 2 0 100 4 2 2 0 000-4z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "medical-examination-outline_svg__clip0_230_2228"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgMedicalExaminationOutline;